<template>
  <div>
    <v-autocomplete
      v-model="searchText"
      @change="onSearch"
      hide-details="auto"
      class="justify-content-end searchbar align-self-center customgrid-search-bar"
      :items="columnList"
      item-text="fullname"
      item-value="id"
      dense
      outlined
      clearable
      :label="$t('search')"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  data() {
    return {
      searchText: "",
      columnList: [],
    };
  },
  props: {
    columnHeader: String,
    onCustomEvent: Function,
  },
  created() {
    eventBus.$on("clear-filters", this.clearFilters);
    this.fetchAllLocationManagers();
  },
  mounted() {
    if (sessionStorage.getItem("salesContact")) {
      this.searchText = parseInt(sessionStorage.getItem("salesContact"));
    }
  },
  methods: {
    clearFilters() {
      this.searchText = "";
      const columnHeader = this.params.columnHeader;

      if (columnHeader == "salesContact") {
        sessionStorage.removeItem("salesContact");
      }
    },
    fetchAllLocationManagers() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/user/locationManager")
        .then(function (response) {
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            if (Number.isInteger(element)) {
              _this.fetchSingleLocationManagerAndPush(element);
            } else {
              _this.columnList.push(element);
            }
          }
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    fetchSingleLocationManagerAndPush(locationManagerId) {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/user/" + locationManagerId)
        .then(function (response) {
          const element = response.data;
          _this.columnList.push(element);
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    onFinally() {
      showLoadingCircle(false);
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    onSearch() {
      const searchText = this.searchText;
      const columnHeader = this.params.columnHeader;
      if (columnHeader == "salesContact") {
        sessionStorage.setItem("salesContact", searchText);
      }
      this.$parent.$listeners.onFilterChanged(columnHeader, searchText);
    },
  },
};
</script>
